import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusModule } from '../../../../../frontend-status-bar/src/lib';

@NgModule({
  declarations: [],
  imports: [CommonModule, StatusModule],
  exports: [],
})
export class AudioModule {}
